import Skeleton from "../../Common/Skeleton";

const AccountListSkeleton = ({ rows = 6 }) => {
  return (
    <Skeleton className="overflow-hidden rounded-2xl">
      {/* Header */}
      <div className="flex items-center justify-between px-5 py-4 border-b border-divider">
        <Skeleton className="h-6 w-36 rounded-lg" />
        <Skeleton className="h-4 w-14 rounded-md" />
      </div>

      {/* Accounts */}
      <div>
        {Array.from({ length: rows }).map((_, index) => (
          <div
            key={index}
            className={`flex items-center justify-between px-4 py-4 ${
              index !== rows - 1 ? "border-b border-divider" : ""
            }`}
          >
            {/* Left */}
            <div className="flex items-center gap-3">
              <Skeleton className="h-11 w-11 rounded-full shrink-0" />

              <div className="space-y-2">
                <Skeleton className="h-5 w-16 rounded-md" />
                <Skeleton className="h-3 w-28 rounded-md" />
              </div>
            </div>

            {/* Right */}
            <div className="flex flex-col items-end gap-2">
              <Skeleton className="h-5 w-28 rounded-md" />
              <Skeleton className="h-4 w-12 rounded-md" />
            </div>
          </div>
        ))}
      </div>
    </Skeleton>
  );
};

export default AccountListSkeleton;